import React, { forwardRef } from 'react';
import MUICardActionArea, {
  CardActionAreaProps as MUICardActionAreaProps,
} from '@material-ui/core/CardActionArea';

export interface CardActionAreaProps extends MUICardActionAreaProps {}

const CardActionArea = forwardRef<HTMLButtonElement, CardActionAreaProps>(
  (props, ref) => {
    return <MUICardActionArea {...props} ref={ref} />;
  }
);

CardActionArea.displayName = 'CardActionArea';

export default CardActionArea;
